import { render, staticRenderFns } from "./UserConfigDialog.vue?vue&type=template&id=292b9753&"
import script from "./UserConfigDialog.vue?vue&type=script&lang=ts&"
export * from "./UserConfigDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports